module.exports = __webpack_public_path__ + "static/img/modal-success.5b86623a.png";